<!--行情-->
<template>
    <div class="id">
        <div class="title">
            <van-image width="18" height="18" :src="require('@/assets/img/footer/home11.png')" />
            <div style="padding-left: 15px;">{{ $t('市场行情') }}</div>
        </div>
        <van-search v-model="value" show-action :placeholder="$t('请输入搜索关键词')" background="#000">
            <template #action>
                <div @click="productList">{{ $t('搜索') }}</div>
            </template>
        </van-search>

        <van-tabs v-model="active" @change="onChange" background="#000" title-active-color="#ffffff"
            title-inactive-color="#888" color="#dfdfdf">
            <van-tab v-for="item in source" :key="item.id" :title="item.name">
                <div class="table">
                    <!-- 表头 -->
                    <van-row class="header">
                        <van-col span="10" class="vanItem">{{ $t('币种') }}</van-col>
                        <van-col span="7" class="vanItem">{{ $t('收盘价') }}</van-col>
                        <van-col span="7" class="vanItem">{{ $t('市场交易') }}</van-col>
                    </van-row>
                    <!-- 数据 -->
                    <div class="scroll">
                        <van-row v-for="item in users" :key="item.id" class="row">
                            <van-col span="10" class="rowItem">
                                <van-icon name="star" color="#ffffff" size="16" v-if="item.selected == 0"
                                    @click="recentOrder(item)" />
                                <van-icon name="star" color="#f0c163" size="16" v-else @click="recentOrder(item)" />
                                <van-image width="34" style="padding-left:6px;" :src="item.image" />
                                <div style="padding-left: 12px;font-size: 12px;">
                                    <div>{{ item.symbol }}</div>
                                    <div style="padding-top: 6px;">{{ item.currency }}</div>
                                </div>
                            </van-col>
                            <van-col span="7" style="text-align: center;">{{ item.open_price }}</van-col>
                            <van-col span="7" class="trade">
                                <div class="box" @click="trade(item)">{{ $t('交易') }}</div>
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </van-tab>
        </van-tabs>
        <Footer></Footer>
    </div>
</template>
<script>
import { get, post } from '@/http/request'
import Footer from '@/common/mobile/Footer.vue'
import { socketUrl } from "@/config.js";
import io from "socket.io-client";

export default {
    components: {
        Footer
    },
    data() {
        return {
            value: '',
            active: 0,
            source: [],
            users: [],
            socket: null
        };
    },
    mounted() {
        this.productTypeList()
        this.productList()
    },
    beforeDestroy() {
        if (this.socket) {
            this.socket.close();
            this.socket = null;
        }
    },
    methods: {
        onChange(name, title) {
            console.log("切换到", name, title)
            console.log(this.active);
            this.productList()
        },
        async productTypeList() {
            const res = await get(this.$apis.getProductTypeList)
            if (res.code == 1) {
                this.source = res.data
                return
            }
            this.$toast(res.msg);
        },

        async productList() {
            const res = await get(this.$apis.getProductList, { type: this.active, title: this.value })
            if (res.code == 1) {
                this.users = res.data
                this.startSocket()
                return
            }
            this.$toast(res.msg);
        },
        trade(item) {
            this.$router.push(`/mobile/trade?code=${item.symbol}`)
        },

        async recentOrder(item) {
            console.log(item.selected);
            const res = await post(this.$apis.operateUserProduct, { product_ids: item.id, type: item.selected == 0 ? 1 : 2 })
            if (res.code == 1) {
                this.productList()
                return
            }
            this.$toast(res.msg);
        },
        startSocket() {
            this.socket = io(socketUrl, { path: '/wss', transports: ['websocket'] });
            this.socket.on('connect', () => {
                console.log('✅ 已连接123');
                this.socket.emit("subscribe", "market");
            });
            this.socket.on("market", (msg) => {
                console.log(this.users);
                console.log("📩 收到 market 数据:", msg);
                this.users = this.users.map(item => {
                    if (item.code === msg.code) {
                        // 用 msg 更新对应的项
                        return { ...item, open_price: msg.price };
                    }
                    return item;
                });


            });
        },
    },
};
</script>
<style lang="less" scoped>
.id {
    color: #fff;
    padding: 0 15px;
    padding-bottom: 60px;
    padding-top: 50px;
    font-size: 14px;

    ::v-deep .van-search__action:active {
        background-color: transparent !important;
    }

    ::v-deep .van-search__action {
        color: #fff;
        margin-left: 10px;
    }

    ::v-deep .van-search__content {
        background-color: #000;
        border: 1px solid #999 !important;
        color: #323233;
        border-radius: 6px;
        overflow: hidden;
    }

    ::v-deep .van-field__control {
        color: #fff;
    }

    .title {
        display: flex;
        align-items: center;
        font-size: 30px;
        padding-bottom: 20px;
        padding-top: 30px;
    }

    .table {
        background: #000;
        color: #fff;
        margin-top: 10px;

        .header {
            font-weight: bold;
            background: #1c222c;
            padding: 14px 0;
            border-radius: 5px;

            .vanItem {
                text-align: center;
            }
        }

        .scroll {
            overflow-y: auto;
            height: 56vh;
            scrollbar-width: none;
            /* Firefox */
            -ms-overflow-style: none;
            /* IE/Edge */
        }

        .row {
            border-bottom: 1px solid #222b39;
            padding: 20px 15px;
            display: flex;
            align-items: center;


            .rowItem {
                display: flex;
                align-items: center;
            }

            .trade {
                text-align: right;

                .box {
                    border: 1px solid #fff;
                    padding: 5px 20px;
                    border-radius: 30px;
                    display: inline-block;
                    font-size: 12px;
                }

            }
        }
    }
}
</style>
